import type { GenerationStatus } from "@sonic-five-elements/contracts";

const labels: Partial<Record<GenerationStatus, string>> = {
  PENDING: "Waiting for the music studio",
  LEASED: "Preparing your session",
  SUBMITTING: "Submitting your composition",
  SUBMITTED: "Queued with the music model",
  RUNNING: "Composing your music",
  GENERATED: "Preparing the audio file",
  ARCHIVING: "Saving your music",
  READY_TEMPORARY: "Ready — available for 24 hours",
  READY_ARCHIVED: "Ready",
  SUBMISSION_UNKNOWN: "Submission needs review",
  FAILED: "Generation failed",
  CANCELLED: "Generation cancelled",
  EXPIRED: "Expired"
};

export function StatusBadge({ status }: { status: GenerationStatus }) {
  const ready = status.startsWith("READY");
  const failed = ["FAILED", "CANCELLED", "SUBMISSION_UNKNOWN", "EXPIRED"].includes(status);
  return <span className={`status-badge ${ready ? "ready" : failed ? "failed" : "working"}`}>{labels[status] || status}</span>;
}

